import { H1, H2 } from "../../../components";
import { useBreakpoints } from "../../../modules/hooks";

const StepTitle = ({ children }) => {
  const breakpoints = useBreakpoints();
  return breakpoints.get({ xs: <H2>{children}</H2>, sm: <H1>{children}</H1> });
};
export default StepTitle;
